import React, { Component } from "react";
import { observer } from "mobx-react";

import "./index.scss";
import { GetQueryParam, GotoTop } from "@/utils/setting";
import Loading from "@/components/loading";
import Hero from "./hero";
import Menu from "./menu";
import Store from "@/stores";

@observer
class LadderDetail extends Component {
	componentDidMount() {
		const { btag, hero, server } = GetQueryParam();
		const { getHero, getTarget } = Store._ladderStore;
		GotoTop();
		getHero(btag, hero, server);
		getTarget(btag);
	}
	render() {
		const { target, targetLoading } = Store._ladderStore;
		if (targetLoading) return <Loading />;
		return (
			<div className="ladder-detail">
				{target && <Menu />}
				<Hero />
			</div>
		);
	}
}
export default LadderDetail;